import { Component, Host, h, Element, State, Prop } from '@stencil/core';
import { handlePromoView } from '@aha-app/aha-shared';

/**
 * Starter component
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-promo-view-pixel',
  styleUrl: 'aha-promo-view-pixel.css',
  shadow: true,
})
export class AhaPromoViewPixel {
  @Element() host!: HTMLAhaPromoViewPixelElement;

  /**
   * The snake case name of the upgrade location, found in SuiteHelper::ANALYTICS_TRACKING_PROPS.
   * The upgrade location is used to infer the promoted product, which then informs the tracking event details.
   */
  @Prop() upgradeLocation!: string;

  /**
   * If pixel is inside a menu, pass through the parent menu selector so the pixel can fire when the menu is opened.
   */
  @Prop() parentElementSelector?: string;

  @State() viewEventFired: boolean = false;
  @State() parentElement: null | HTMLElement = null;

  private observer: any;
  private mutationObserver: any;
  componentDidLoad() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!this.viewEventFired && this.upgradeLocation && entry.isIntersecting) {
            this.viewEventFired = true;
            handlePromoView(this.upgradeLocation);
          }
        });
      },
      { threshold: 1 },
    );

    if (this.parentElementSelector) {
      this.parentElement = document.querySelector(this.parentElementSelector);

      this.mutationObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            if (this.parentElement && this.host) {
              if (this.parentElement.classList.contains('open')) {
                this.observer.observe(this.host);
              } else {
                this.observer.unobserve(this.host);
              }
            }
          }
        });
      });
    }

    if (this.parentElement && this.host) {
      this.mutationObserver.observe(this.parentElement, {
        attributes: true,
      });
    } else if (this.host) {
      this.observer.observe(this.host);
    }
  }

  connectedCallback() {
    if (this.mutationObserver) {
      this.mutationObserver.observe(this.parentElement, {
        attributes: true,
      });
    } else if (this.observer) {
      this.observer.observe(this.host);
    }
  }

  disconnectedCallback() {
    if (this.mutationObserver) {
      this.mutationObserver?.disconnect();
    } else if (this.observer) {
      this.observer?.disconnect();
    }
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
